module.exports = __webpack_public_path__ + "img/pause.1a38a358.png";